(function (scope) {
  function engravingState(value, limit, skyline) {
    const text = String(value || '');
    const maximum = limit === null || limit === '' ? null : Number(limit);
    const symbols = ['♡', '~', '❀', '✡'].map(symbol => text.split(symbol).length - 1);
    const count = text.length + (skyline ? 22 : 0);
    const exceedsCharacters = Number.isFinite(maximum) && count > maximum;
    const exceedsSymbols = symbols[0] > 2 || symbols[1] > 3 || symbols[2] > 1 || symbols[3] > 3 || symbols.reduce((sum, value) => sum + value, 0) > 3;
    return { count, maximum, exceedsCharacters, exceedsSymbols, valid: !exceedsCharacters && !exceedsSymbols };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { engravingState };
  if (!scope.document) return;

  const document = scope.document;
  const controllers = new Map();

  function initialize(root) {
    if (controllers.has(root)) return;
    let queued = false;
    const locked = new Map();

    function reconcile() {
      const settings = root.querySelector('#myvars');
      if (!settings) return true;
      const skyline = typeof scope.getSkylineSelected === 'function' ? scope.getSkylineSelected() : 'none';
      let invalid = false;
      for (const side of ['front', 'back']) {
        const field = root.querySelector('.' + side + '_tbox textarea');
        if (!field) continue;
        const state = engravingState(field.value, settings.getAttribute('max_words_' + side), skyline === side + ' only' || skyline === 'both sides');
        invalid = invalid || !state.valid;
        field.setAttribute('aria-invalid', String(!state.valid));
        const counter = root.querySelector('#current_words_' + side);
        if (counter && counter.textContent !== String(state.count)) counter.textContent = String(state.count);
        const wrapper = field.closest('.' + side + '_tbox')?.querySelector('.word_counter_wrapper');
        if (wrapper) {
          wrapper.classList.toggle('red_alert', !state.valid);
          wrapper.classList.toggle('symbols_max', state.exceedsSymbols);
          for (const name of ['heart_max', 'tilde_max', 'flower_max', 'sod_max']) wrapper.classList.remove(name);
        }
        const remaining = Number.isFinite(state.maximum) ? String(state.maximum - state.count) : '';
        if (settings.getAttribute(side + '2go') !== remaining) settings.setAttribute(side + '2go', remaining);
      }
      for (const button of root.querySelectorAll('.product-form__submit')) {
        if (invalid) {
          if (!locked.has(button)) locked.set(button, button.disabled);
          button.disabled = true;
        } else if (locked.has(button)) {
          const prior = locked.get(button);
          locked.delete(button);
          button.disabled = prior || root.dataset.hadayaProductAvailable === 'false';
        }
      }
      return !invalid;
    }

    function schedule() {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; reconcile(); });
    }

    function blockInvalid(event) {
      if (event.type === 'click' && !event.target.closest('.product-form__submit')) return;
      if (event.type === 'submit' && !event.target.matches('form[data-type="add-to-cart-form"]')) return;
      if (reconcile()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      root.querySelector('textarea[aria-invalid="true"]')?.focus();
    }

    for (const name of ['input', 'change', 'keyup', 'click']) root.addEventListener(name, schedule);
    root.addEventListener('click', blockInvalid, true);
    root.addEventListener('submit', blockInvalid, true);
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['max_words_front', 'max_words_back'] });
    controllers.set(root, { reconcile, destroy() { observer.disconnect(); for (const name of ['input', 'change', 'keyup', 'click']) root.removeEventListener(name, schedule); root.removeEventListener('click', blockInvalid, true); root.removeEventListener('submit', blockInvalid, true); controllers.delete(root); } });
    reconcile();
  }

  scope.hadayaEngravingValidate = function () {
    let valid = true;
    for (const controller of controllers.values()) valid = controller.reconcile() && valid;
    return valid;
  };
  function boot() { document.querySelectorAll('[id^="MainProduct-"]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => { for (const [root, controller] of controllers) if (event.target.contains(root)) controller.destroy(); });
})(typeof window === 'undefined' ? {} : window);
